export const NodeTypes = {
  CIRCUIT: "circuit",
  EVCHARGER: "evCharger",
  ADDNODE: "addNode"
};

